import { Box } from '@mui/material';
import LandingNavbar from '../components/landing/LandingNavbar';
import HeroSection from '../components/landing/HeroSection';
import FeatureShowcase from '../components/landing/FeatureShowcase';
import TestimonialSection from '../components/landing/TestimonialSection';
import CTASection from '../components/landing/CTASection';
import FooterSection from '../components/landing/FooterSection';

/**
 * Public-facing landing page — single scrollable page composed of all
 * landing sections. Rendered outside the Layout sidebar for visitors
 * who are not logged in.
 */
export default function LandingPage() {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <LandingNavbar />
      <HeroSection />
      <FeatureShowcase id="features" />
      <TestimonialSection id="testimonials" />
      <CTASection />
      <FooterSection />
    </Box>
  );
}
